export default function snakeCase(str: string) {
  return str.toLowerCase().split(' ').join('_');
}
